import type { BlogHomeLayout, DbPost } from './types';

export const TEMPLATED_POST = {
  slug: `templated-post`,
  id: 'templated-post-id',
  title: 'Templated post',
};

export function getTemplatedPost(subdomain: string): DbPost {
  return {
    ...TEMPLATED_POST,
    coverImage: null,
    excerpt: `This is the template, it will be removed once you create a note inside the \`${subdomain}.quotion.co\` folder`,
    featured: true,
    draft: false,
    hidden: false,
    searchEngineIndexing: false,
    md: `## Quotion template

This is the template, it will be removed once you create a note inside the \`${subdomain}.quotion.co\` folder.
`,
    hasSetupComment: true,
    likeCount: 0,
    tags: 'template',
    folders: [],
    publishAt: null,
    metaTitle: '',
    metaDescription: '',
    createdAt: new Date(),
    updatedAt: new Date(),
  };
}

export type HeroMeta = {
  decorator: string;
  title: string;
  subtitle: string;
};
export type AcmeHomeLayout = Omit<BlogHomeLayout, 'hero'> & {
  hero: HeroMeta;
};

export const ACME_HOME_LAYOUT: AcmeHomeLayout = {
  logo: '/.quotion/acme/logo.png',
  favicon: '/.quotion/acme/favicon.png',
  headerLinks: [
    {
      name: 'Home',
      href: '/',
    },
  ],
  footerLinks: [
    {
      name: 'Home',
      href: '/',
    },
    {
      name: 'RSS',
      href: '/rss.xml',
    },
    {
      name: 'Site Map',
      href: '/sitemap.xml',
    },
  ],
  copyright: `©Copyright ${new Date().getFullYear()} Acme.`,

  hero: {
    decorator: 'Acme Blog',
    title: 'Explore Our Creative Universe: Insights & Inspirations',
    subtitle:
      'The latest industry news, technologies and resources from the team.<br/>(This is the template, learn how to <a href="https://docs.quotion.co/features/customize-layout">customize your site layout</a>)',
  },
};
